import { Router, Route, Switch } from 'wouter';
import { GameProvider } from './state/GameContext.jsx';
import TitleScreen from './screens/TitleScreen.jsx';
import HostFlowScreen from './screens/HostFlowScreen.jsx';
import PlayerJoinScreen from './screens/PlayerJoinScreen.jsx';
import PlayerFlowScreen from './screens/PlayerFlowScreen.jsx';
import SoloScreen from './screens/SoloScreen.jsx';
import RankingScreen from './screens/RankingScreen.jsx';

export default function App() {
  return (
    <GameProvider>
      <Router>
        <Switch>
          <Route path="/" component={TitleScreen} />
          <Route path="/host" component={HostFlowScreen} />
          <Route path="/join" component={PlayerJoinScreen} />
          <Route path="/play" component={PlayerFlowScreen} />
          <Route path="/solo" component={SoloScreen} />
          <Route path="/rankings" component={RankingScreen} />
          <Route><TitleScreen /></Route>
        </Switch>
      </Router>
    </GameProvider>
  );
}
